import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { variableCurrencyValue } from '../../field-table';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import { get } from 'immutadot';
import { asMoneyWithDivisor, getObjectByPath } from '../../../utils';
//import CurrencyInput from "../../currency-input";
import {CurrencyField} from "../../CurrencyInput";
import { useDaybookContext } from '../../../contexts/Daybook/DayBookContext';


export function FieldTableCurrencyColumn(): ReactElement|void {
    const context = useContext(FieldTableSettingsContext);
    const daybook = useDaybookContext();
    useEffect(() => {
        if(!context) return;
        context.registerType({
            dataType: 'currency',
            width: () => 'minmax(8em,max-content)',
            className: () => 'column-currency',
            // eslint-disable-next-line react/display-name
            renderViewer: (props: FieldRendererProps<any,any>) => {
                const currency = props.options?.currency?.accessor?get(props.row,props.options?.currency?.accessor)??props.defaultCurrency:props.defaultCurrency;
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                if((value==null||value==undefined) && (props.nullRenderAs!=undefined)) {
                    return props.nullRenderAs;
                }
                console.log('currency is',currency,props.options?.currency?.accessor,props.defaultCurrency,get(props.row,props.options?.currency?.accessor),props.row);
                const showGlyph = daybook?.theme!='daybook' ? (props.options?.showGlyph ?? true): true;
                if(props.options?.currency?.divisorAccessor) {
                    const uv = parseInt(value??'0');
                    const pd = props?.options?.currency?.divisorAccessor?parseInt(get(props.row,props.options?.currency?.divisorAccessor),10)??1:1;
                    return (currency?.glyph)+asMoneyWithDivisor({value:uv,divisor:pd,places:0,comma:true});
                } else {
                    return variableCurrencyValue({ currency: currency, value: value, places: 2, qty: 1, comma: true, showGlyph: showGlyph });
                }
            },
            // eslint-disable-next-line react/display-name
            renderEditor: (props: FieldRendererProps<any,any>) => {
                const options:any = {...props.field};
                //options.value = (props.options?.getValue) ? props.options.getValue(props) : props.field.value;
                options.value = props.field.value;
                options.onChange = props.options?.onChange? (evt)=>{props.options.onChange(evt,props); }:props.field.onChange;
                options.currencySelect = !!props.options?.currency?.accessor;
                options.currencyValueIsId = props.options?.currency?.currencyValueIsId;
                options.allowContextCurrency = props.options?.currency?.allowContextCurrency;
                options.currencyAccessor = props.options?.currency?.accessor?props.rowName+'.'+props.options.currency?.accessor:null;
                options.divisorAccessor = props.options?.currency?.divisorAccessor?props.rowName+'.'+props.options.currency?.divisorAccessor:null;
                options.currency = options.currencyAccessor?getObjectByPath(props.row,props.options?.currency?.accessor):null;
                options.showGlyph = props.options?.showGlyph??true;
                console.log('CURRENCYEDITOR',props.options?.currency?.accessor,'from',props.row,'as',options.currency);
                if(options.divisorAccessor) {
                    options.divisor = get(props.row,props.options?.currency?.divisorAccessor);
                } else {
                    options.places = props.options?.currency?.places??2;
                }
                options.raw =  !!props.options?.currency?.raw;
                console.log('CURRENCYEDITOR with',options);
                return <CurrencyField {...options} autoFocus={true} />;
            },
            renderExport:(cell,props: FieldRendererProps<any,any>):any => {
                const value = props.options?.getValue?props.options.getValue(props):props.field.value;
                const currency = props.options?.currency?.accessor?get(props.row,props.options?.currency?.accessor)??props.defaultCurrency:props.defaultCurrency;

                cell.t = 'n';
                const displayValue = value / 100;
                const showGlyph = daybook?.theme!='daybook' ? (props.options?.showGlyph ?? true): true;
                cell.v = isNaN(displayValue) || displayValue === null ? 0 : displayValue;
                cell.width = (''+Math.floor(cell.v)).length +4; // digits before dot then add dot, 00, currency glyph
                console.log('width',value,''+Math.floor(cell.v),cell.width);
                cell.z = showGlyph ? ('"' + (currency?.glyph) + '"' + '#,##0.00') : '#,##0.00';
                return cell;
            }

        });
    }, [context, daybook?.theme]);
    return;
}
